// extracted by mini-css-extract-plugin
export default {"popper":"styles_popper__GLP98","wrapper":"styles_wrapper__dYWL+"};